import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import AlertMessage, { AlertLevel } from "../../../components/AlertMessage";
import { SharedAlert } from "../../../app/siteSlice";
import PromptLibrary from "../PromptLibrary";

export default function AdminPrompts() {
	const [alert, setAlert] = useState<SharedAlert>({ level: AlertLevel.Warning, message: "" });
	const [selectedPromptId, setSelectedPromptId] = useState<number>();
	const [searchFilter, setSearchFilter] = useState("");

	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		if (location.state != null) {
			setAlert({ level: AlertLevel.Error, message: location.state.errorMessage });
			setSearchFilter(location.state.promptName);
			setSelectedPromptId(location.state.promptId);
		}
		navigate(location, { replace: true });
	}, []);

	return (
		<>
			<section>
				<h1>Prompts</h1>
				{alert.message && (
					<AlertMessage
						className="mt-4 text-sm"
						type={alert.level}
						message={alert.message}
						showIcon={true}
						onClear={() => setAlert({ ...alert, message: "" })}
					/>
				)}
				<PromptLibrary
					setAlert={setAlert}
					searchFilter={searchFilter}
					selectedPromptId={selectedPromptId}
				/>
			</section>
		</>
	);
}
